import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.Diner;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "Diner.Phaser.IntroductionScene.1",
            "Diner.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/DinerGame/scenes/GameIntro.ts